/**
 * Payment configuration file
 * This file contains configuration for payment processors and methods
 * Change these values to switch between payment processors
 */

export const paymentConfig = {
    // Available options: 'cardbilling' or 'stripe'
    // paymentProcessor: 'stripe',
    paymentProcessor: 'cardbilling',
    
    // Available options: 'CC' (for cardbilling) or 'credit_card' (for stripe)
    // paymentMethod: 'credit_card',
    paymentMethod: 'CC',
}

export default paymentConfig
